import { autoinject } from 'aurelia-framework';
import { UserModel } from '~/api/user-service';

const styles = {
	body: 'a-modifiedby__body',
	label: 'a-modifiedby__label',
	value: 'a-modifiedby__value',
	row: 'a-modifiedby__row',
	tooltip: 'a-modifiedby__tooltip',
	tooltipInner: 'a-modifiedby__tooltip__inner',
};

@autoinject
export class UserInfoTooltipUtils {
	public static isTooltipInitializedDataAttr: string =
		'data-tooltip-initialized';

	public static setTooltipTitle(elem: HTMLElement, title: string) {
		if (!elem) {
			return;
		}
		if (
			!title &&
			elem.getAttribute(
				UserInfoTooltipUtils.isTooltipInitializedDataAttr,
			) === 'true'
		) {
			// Reset
			$(elem).tooltip('dispose');
			elem.setAttribute(
				UserInfoTooltipUtils.isTooltipInitializedDataAttr,
				'false',
			);
			return;
		}
		if (
			elem.getAttribute(
				UserInfoTooltipUtils.isTooltipInitializedDataAttr,
			) !== 'true'
		) {
			const defaultTooltip: Bootstrap.TooltipOption = {
				delay: {
					show: 500,
					hide: 100,
				},
				container: 'body',
				title: '',
				placement: 'right',
				html: true,
				template: `<div class="tooltip ${styles.tooltip}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner ${styles.tooltipInner}"></div></div>`,
			};
			$(elem).tooltip(defaultTooltip);
			$(elem).attr('data-original-title', title);
			elem.setAttribute(
				UserInfoTooltipUtils.isTooltipInitializedDataAttr,
				'true',
			);
		} else {
			$(elem).tooltip('update');
			$(elem).attr('data-original-title', title);
		}
	}

	public static getDefaultUserInfoTooltipContent(userModel: UserModel) {
		return `
		<ul class="${styles.body}">
			<li class="${styles.row}">
				<span class="${styles.label}">
					Identity
				</span>
				<div class="${styles.value}">
					${userModel.id.escapeHtml()}
				</div>
			</li>
			<li class="${styles.row}">
				<span class="${styles.label}">
					Web User
				</span>
				<div class="${styles.value}">
					${userModel.userLoginName.escapeHtml()}
				</div>
			</li>
			<li class="${styles.row}">
				<span class="${styles.label}">
					Surname
				</span>
				<div class="${styles.value}">
					${userModel.surname.escapeHtml()}
				</div>
			</li>
			<li class="${styles.row}">
				<span class="${styles.label}">
					Given Name
				</span>
				<div class="${styles.value}">
					${userModel.givenName.escapeHtml()}
				</div>
			</li>
		</ul>
		`;
	}
}
